// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { ProviderResponse } from './provider-response';

// @ts-ignore
import { RapidReviewEyeglassEyeResponse } from './rapid-review-eyeglass-eye-response';

/** See com.rev360.pms.api.controller.encounter.rapidreview.RapidReviewEyeglassPrescriptionResponse */
/* istanbul ignore next */
@GandalfModel
export class RapidReviewEyeglassPrescriptionResponse extends GandalfModelBase {

	@GandalfConstantDecorator(constants.PrescriptionAuthorizationType)
	@GandalfProperty({ designType: constants.PrescriptionAuthorizationType })
	authorizationType!: constants.PrescriptionAuthorizationType;

	@GandalfProperty({ designType: ProviderResponse })
	authorizedBy!: ProviderResponse | null;

	@GandalfProperty({ designType: Date })
	expirationDate!: Date | null;

	@GandalfProperty({ designType: Number })
	eyeglassPrescriptionId!: number;

	@GandalfProperty({ designType: RapidReviewEyeglassEyeResponse })
	od!: RapidReviewEyeglassEyeResponse;

	@GandalfProperty({ designType: RapidReviewEyeglassEyeResponse })
	os!: RapidReviewEyeglassEyeResponse;

	@GandalfConstantDecorator(constants.PrescriptionCurrentStatus)
	@GandalfProperty({ designType: constants.PrescriptionCurrentStatus })
	status!: constants.PrescriptionCurrentStatus;

	@GandalfProperty({ designType: String })
	usedFor!: string | null;

}
